/* gr-account.js — country/province dropdown cascade for address forms.
 * Uses Shopify's built-in CountryProvinceSelector (loaded via {{ 'shopify_common.js' | shopify_asset_url }})
 * If unavailable, falls back to hiding province field when country has no subregions.
 */
(function(){
  'use strict';
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-gr-country]').forEach(function(countryEl){
      var provinceEl = countryEl.closest('form').querySelector('[data-gr-province]');
      if (!provinceEl) return;
      var defCountry = countryEl.dataset.default;
      var defProvince = provinceEl.dataset.default;

      function setProvinces() {
        var opt = countryEl.options[countryEl.selectedIndex];
        var raw = opt ? opt.getAttribute('data-provinces') : '[]';
        var provinces = [];
        try { provinces = JSON.parse(raw); } catch(e) {}
        provinceEl.innerHTML = '';
        if (!provinces.length) { provinceEl.closest('.gr-field').style.display = 'none'; return; }
        provinceEl.closest('.gr-field').style.display = '';
        provinces.forEach(function(p){
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          if (p[0] === defProvince) o.selected = true;
          provinceEl.appendChild(o);
        });
      }

      if (defCountry) {
        for (var i=0;i<countryEl.options.length;i++) {
          if (countryEl.options[i].value === defCountry) { countryEl.selectedIndex = i; break; }
        }
      }
      countryEl.addEventListener('change', setProvinces);
      setProvinces();
    });
  });
})();
